import React, {useEffect, useState} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import {Link} from 'react-scroll'



const About = () => {

  return (
    <div name='about' className='w-full min-h-screen py-20 my-24 bg-[rgb(255,255,255)] text-black '>
        <div className='flex flex-col justify-center items-center w-full h-full'>
            <div className='max-w-[1000px] w-full grid grid-col-2 gap-8'>
                <div className='p-8 sm:text-left pb-8 pl-4'>
                    <p className='text-4xl font-bold inline border-b-2 border-[#d4d4d4] cursor-default'>About me</p>
                </div>
                <div className='max-w-[1000px] w-full grid sm:grid-col-2 gap-6 px-4'>
                    <div className='sm:text-left text-2xl'>
                        <p>You can find some informations about me here ↓</p>
                    </div>
                    <div className='p-8 pb-6 pl-4'>
                        <Accordion>
                            <AccordionSummary id="panel-header" aria-controls="panel-content">
                                <button className='cursor-default text-2xl font-bold inline border-b-2 border-[#d4d4d4]'>Coding</button><br />
                            </AccordionSummary>
                                <AccordionDetails>
                                    <div className='py-2 '>
                                    <p>I have almost 4,5 year of experience in making sites. Within these 4,5 year, I done a few websites. <br/>
                                        Check out them here → <Link to='experience' className='underline cursor-pointer hover:text-[#858585]'>projects</Link> <br/>
                                        Now I am searching for clients to do new websites for them and searching for company where I will can develop my skills.</p>
                                    </div>
                                </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary id="panel-header" aria-controls="panel-content">
                                <button className='cursor-default text-2xl font-bold inline border-b-2 border-[#d4d4d4]'>Video editing</button><br />
                            </AccordionSummary>
                                <AccordionDetails>
                                    <div className='py-2 '>
                                    <p>Now, I am video editor for daily basis. I'm working for company called <a href='https://pccpoland.pl/' className='underline decoration-blue-300 font-bold' target='_blank'>PCC Poland</a> that I am doing for them videos and looking for new clients. <br/>
                                    Working with companies which making wedding videos too. Here are some of my projects done → <a href="https://www.youtube.com/playlist?list=PLwhUH9NNZwWNM9ZjUn3jvtaZORMR-xtjQ" className='underline hover:text-[#858585]' target='_blank'>weddings</a> <br/>
                                    And there it is some projects that I done with my other clients (courses, biggest IT conferences in Poland etc.) → <a href="https://www.youtube.com/playlist?list=PLwhUH9NNZwWP_Ab7RaPdFYzvc22TTVCrB" className='underline hover:text-[#858585]' target='_blank'>Portfolio</a>
                                    </p>
                                    </div>
                                </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary id="panel-header" aria-controls="panel-content">
                                <button className='cursor-default text-2xl font-bold inline border-b-2 border-[#d4d4d4]'>What's next?</button><br />
                            </AccordionSummary>
                                <AccordionDetails>
                                    <div className='py-2 '>
                                    <p className='py-2'>What am I looking for in future? <br/> I am on university and still develop my skills. For not so far future, I am going into databeses and cloud engineering.</p>
                                    </div>
                                </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}


export default About